var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.607,
    height: 25.738,
    viewBox: "0 0 38.607 25.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-toggle-on",
    "data-name": "Icon fa-solid-toggle-on",
    d: "M12.869,3a12.869,12.869,0,1,0,0,25.738H25.738A12.869,12.869,0,0,0,25.738,3ZM25.738,9.434A6.434,6.434,0,1,1,19.3,15.869,6.434,6.434,0,0,1,25.738,9.434Z",
    transform: "translate(0 -3)",
    fill: "#0ad69f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.9cab233d05297bd6cd91831457fac905.svg";
export { ForwardRef as ReactComponent };